SWR.Social.prototype._loadVimeo = function _loadVimeo() {
  var self = this;

  try {
    var videoId = self.url.match(/(?:www\.|player\.)?vimeo.com\/(?:channels\/(?:\w+\/)?|groups\/(?:[^\/]*)\/videos\/|album\/(?:\d+)\/video\/|video\/|)(\d+)(?:[a-zA-Z0-9_\-]+)?/i).pop();
    var html = COMMON.Utils.template(
      '<div class="embed-responsive embed-responsive-16by9">' +
      '<iframe class="embed-responsive-item" src="https://player.vimeo.com/video/{videoId}?title=0&byline=0&portrait=0&color=ffffff&dnt=1&app_id=122963" allowFullScreen="true" style="top: 0px; left: 0px; width: 100%; height: 100%; position: absolute; border: 0;"></iframe>' +
      '</div>', {
      'videoId': videoId
    });
    self._done(html);
  } catch (e) {
    self._failed(self.config.embedCookie, self.url);
  }
}
